import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { SPECS } from "@/config/product";

// Compact collapsible rows under the PDP trust row — same white
// accordion-card styling as PdpFaq. Answers reuse confirmed project copy;
// [PLACEHOLDER] entries stay editable until final policies land.
const ROWS = [
  {
    q: "How do preorders work?",
    a: "You're reserving a pair from the first production run. Estimated dispatch: 15th of December — they'll be waiting under the Christmas tree. Secure your pair now 💗 Preorder now to lock in your POSSO clogs before our official launch. First drop quantities are limited! You'll be notified once we ship.",
  },
  { q: "Specifications", specs: true },
  {
    q: "Shipping, returns & refunds",
    a: "Free shipping Australia-wide on every order. Wrong size? We've got you. 💗 Easy size exchanges within 30 days of delivery — you cover return postage, and we'll cover standard delivery of your first replacement pair. Faulty or incorrect products are covered under Australian Consumer Law.",
    link: { to: "/returns-exchanges", label: "View our Returns & Exchanges Policy →" },
  },
];

export default function PdpDetails() {
  const [open, setOpen] = useState(null);

  return (
    <div data-testid="pdp-details" className="mt-9 space-y-2">
      {ROWS.map((r, i) => {
        const isOpen = open === i;
        return (
          <div key={r.q} className="rounded-2xl border-2 border-ink/10 bg-white">
            <button
              data-testid={`pdp-details-question-${i + 1}`}
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 px-3.5 py-3 text-left"
            >
              <span className="font-display uppercase tracking-wide text-[13px] sm:text-sm leading-tight text-ink">
                {r.q}
              </span>
              <ChevronDown
                className={`w-4 h-4 shrink-0 text-ink/50 transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
                strokeWidth={2.5}
              />
            </button>
            {isOpen &&
              (r.specs ? (
                <dl
                  data-testid={`pdp-details-answer-${i + 1}`}
                  className="px-4 pb-4 space-y-1.5"
                >
                  {SPECS.map(([k, v]) => (
                    <div key={k} className="text-sm">
                      <dt className="inline font-semibold text-ink">{k}: </dt>
                      <dd className="inline text-ink/70">{v}</dd>
                    </div>
                  ))}
                </dl>
              ) : (
                <div
                  data-testid={`pdp-details-answer-${i + 1}`}
                  className="px-4 pb-4"
                >
                  <p className="text-sm text-ink/70 leading-relaxed">{r.a}</p>
                  {r.link && (
                    <Link
                      data-testid="pdp-details-returns-link"
                      to={r.link.to}
                      className="mt-1.5 inline-block font-body font-bold text-[11px] tracking-wide uppercase text-[#FF6BAA] underline underline-offset-4"
                    >
                      {r.link.label}
                    </Link>
                  )}
                </div>
              ))}
          </div>
        );
      })}
    </div>
  );
}
